<template lang="pug">
    .formpage(v-if="recaptchaSiteKey && formExtensionEnabled", :class="[spacingTop, spacingBottom, backgroundColor]")
        .container.mx-auto
            //loading(:active="form.loading" :is-full-page="false" :height="40" :width="40" color="#000000")
            .formInfo
                .heading
                    .title(v-if="formTitle") {{ formTitle }}
                .formDesc(v-if="formDesc") {{ formDesc }}
            validation-observer(v-slot="{ invalid }" ref="observer")
                form(@submit.prevent="submit" ref="form")
                    template(
                        v-for="field in form.fields"
                        v-if="! ['email-intro', 'email-content'].includes(field.type)"
                    )
                        Field(v-if="field.type === 'multi-select'", :key="field.id", :field="field", v-model="field.values")
                        Field(v-else-if="field.type === 'upload'", :key="field.id", :field="field", v-model="field.files")
                        Field(v-else :key="field.id", :field="field", v-model="field.value")
                    .columns.send-wrap
                        .field.column.checkbox
                            validation-provider(name="Datenschutzbestimmungen", :rules="{ required: { allowFalse: false } }", v-slot="{ errors }")
                                .control
                                    label
                                        input(type="checkbox" v-model="form.privacy")
                                        |  Mit dem Senden meiner Anfrage stimme ich den <router-link class="link" target="_blank" to="/datenschutz">Datenschutzbestimmungen</router-link> zu.
                                p.help.text-red-700(v-if="errors && errors.length") {{ errors[0] }}
                                //p.help.text-grey-dark.text-xs.italic(v-else="required") Pflichtfeld
                        .field.column.is-narrow
                            .control
                                button.button.btn-send(type="submit") {{ submitText }}
</template>

<script>
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
//import Loading from 'vue-loading-overlay';

import { cloneDeep, get, uniqueId } from 'lodash';
import { mapGetters, mapActions } from 'vuex';

import store from '@/store';
import Field from './FormField';

export default {
    name: 'Form',
    components: {
        Error,
        Field
        //Loading
    },
    data() {
        return {
            form: {
                loading: true,
                privacy: false,
                fields: []
            },
            preset: []
        };
    },
    props: {
        section: {
            type: Object
        }
    },
    computed: {
        formTitle() {
            let formTitle = undefined;

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'formTitle');
                if (setting && setting.value !== undefined) formTitle = setting.value;
            }
            return formTitle;
        },

        formDesc() {
            let formDesc = undefined;

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'formDesc');
                if (setting && setting.value !== undefined) formDesc = setting.value;
            }
            return formDesc;
        },

        submitText() {
            let submitText = 'Sekundenschnell abgeschickt';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'submitText');
                if (setting && setting.value !== undefined) submitText = setting.value;
            }
            return submitText;
        },


        backgroundColor() {
            let backgroundColor = 'bg_grey_sickle';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'background_color');
                if (setting && setting.value !== undefined) backgroundColor = setting.value;
            }
            return backgroundColor;
        },
        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },
        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        },
        formExtensionEnabled() {
            return this.cms.enabledExtensionKeys.includes('forms');
        },
        ...mapGetters({
            recaptchaSiteKey: 'googleRecaptchaSiteKey',
            view: 'currentPage/view',
            error: 'error',
            cms: 'CMS'
        })
    },
    methods: {
        async submit() {
            const valid = await this.$refs.observer.validate();
            if (valid && this.recaptchaSiteKey) {
                this.form.loading = true;
                try {
                    await this.$recaptchaLoaded();
                    const token = await this.$recaptcha('contact');

                    console.log(token);

                    const payload = {
                        cms: { id: parseInt(this.cms.id) },
                        section: { id: parseInt(this.section.id) },
                        fields: this.form.fields
                    };

                    store
                        .dispatch('form/sendFormToApi', payload)
                        .then(() => {
                            // reset form
                            this.form.fields = cloneDeep(this.preset);
                            this.$refs.observer.reset();
                            this.$refs.form.reset();
                        })
                        .finally(() => {
                            const message = {
                                id: uniqueId(),
                                title: 'Versendet',
                                text: 'Ihre Nachricht wurde erfolgreich gesendet.',
                                type: 'success',
                                autoclose: 10000
                            };
                            this.addMessage(message);
                            this.form.loading = false;
                        });
                } catch (error) {
                    console.error(error);
                    const message = {
                        id: uniqueId(),
                        title: 'Fehler',
                        text:
                            'Es gibt ein technisches Problem. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                        type: 'danger',
                        autoclose: 5000
                    };
                    store.commit('addMessage', message);
                    this.form.loading = false;
                }
            }
        },
        ...mapActions({
            addMessage: 'message/add'
        })
    },
    mounted() {
        const configs = get(this.section, 'contents') || [];
        const sorted = configs.sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));
        sorted.forEach(config => {
            let type;
            const settings = config.settings || [];
            const setting = settings.find(el => el.key === 'type');
            if (setting) type = setting.value;

            let field = {
                id: uniqueId('new:'),
                key: config.key,
                type: type || config.key,
                title: config.title,
                position: config.position,
                settings: config.settings,
                content: { id: config.id }
            };

            // if (['multi-select', 'upload'].includes(field.type)) field.values = []
            if (field.type === 'multi-select') field.values = [];
            else if (field.type === 'upload') field.files = [];
            else field.value = '';

            this.form.fields.push(field);
            this.preset.push(cloneDeep(field));
        });

        this.form.loading = false;
    },
    beforeMount() {
        if (this.recaptchaSiteKey) {
            Vue.use(VueReCaptcha, {
                siteKey: this.recaptchaSiteKey,
                loaderOptions: {
                    useRecaptchaNet: true
                }
            });
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.formInfo
    @apply mb-6
    .formTitle
        @apply font-bold
        font-size: 2rem
    .formDesc
        @apply mt-4

.link
    @apply underline
    color: $color-primary
    &:hover
        color: darken($color-base-text, 10%)

    

::v-deep
  .send-wrap
    @apply text-left
  .field
    @apply pb-4 mb-0
    &:last-of-type
        @apply pb-0
    .title
        @apply mb-1
    .btn-send
      @apply rounded py-2 px-5 transition duration-150 ease-in-out
      background-color: $color-primary
      border: 0
      line-height: 1.2em
      &:hover
        background-color: darken($color-base-text, 10%) !important

    .multiselect, .multiselect__tags
        background-color: #f5f5f5
        border-color: #e0e0e0
    .dropzone
        background-color: #f5f5f5
        padding: 16px
        text-align: center
        border-bottom: 2px solid #e0e0e0

    .input, textarea
        @apply bg-white rounded border w-full
        border-color: $color-base-text
        transition: border-color 0.2s ease
        padding: 8px

    textarea
      min-height: 150px
</style>
